// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.immunization.PatientHl7ValueSetResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientHl7ValueSetResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	hl7ValueSetId!: number | null;

	@GandalfProperty({ designType: String })
	preferredName!: string | null;

}
